import type { AeTemplateDetail } from '@/types/assessmentEngine';
import { DEMOGRAPHICS_SECTION_CODE } from './templateConfigTypes';
import { findSectionById, topLevelContentSections } from './structureMoveUtils';

export type BuilderDragKind = 'section' | 'question';

export interface BuilderSectionDragData {
  kind: 'section';
  sectionId: string;
  parentSectionId: string | null;
  index: number;
}

export interface BuilderQuestionDragData {
  kind: 'question';
  questionId: string;
  sectionId: string;
  index: number;
}

export type BuilderDragData = BuilderSectionDragData | BuilderQuestionDragData;

export const sectionDndId = (sectionId: string): string => `section:${sectionId}`;
export const questionDndId = (questionId: string): string => `question:${questionId}`;
export const questionsDropDndId = (sectionId: string): string => `questions-drop:${sectionId}`;
export const subsectionDropDndId = (parentSectionId: string): string => `subsection-drop:${parentSectionId}`;

export function parseDndId(id: string): { kind: BuilderDragKind; entityId: string } | null {
  if (id.startsWith('section:')) return { kind: 'section', entityId: id.slice('section:'.length) };
  if (id.startsWith('question:')) return { kind: 'question', entityId: id.slice('question:'.length) };
  return null;
}

export function isDemographicsSectionId(template: AeTemplateDetail, sectionId: string): boolean {
  const sec = findSectionById(template, sectionId);
  return sec?.code === DEMOGRAPHICS_SECTION_CODE;
}

/** Ordered top-level content dimension ids for sortable context. */
export function topLevelSectionDndIds(template: AeTemplateDetail): string[] {
  return topLevelContentSections(template).map((s) => sectionDndId(s.id));
}

export function questionDndIdsForSection(questionIds: string[]): string[] {
  return questionIds.map((id) => questionDndId(id));
}

export function subsectionDndIds(subsectionIds: string[]): string[] {
  return subsectionIds.map((id) => sectionDndId(id));
}
